export default function Canvas_Text_Alignment() {
  return (
    <div>
      <h1>Canvas_Text_Alignment Component</h1>
    </div>
  );
}
